import { copy } from "../copy";
import Icon, { type IconName } from "../components/Icon";
import type { ActivityItem } from "./api";
import { timeAgo } from "./ui";

const KIND: Record<ActivityItem["kind"], { icon: IconName; tone: string }> = {
  entry: { icon: "userAdd", tone: "text-chrome-dim" },
  submission: { icon: "music", tone: "text-gold" },
  review: { icon: "feedback", tone: "text-money" },
  result: { icon: "trophy", tone: "text-gold" },
};

// Joins, submissions, reviews, and results. Stake amounts are never listed:
// a figure tied to a username stays private.
export default function ActivityTab({ items }: { items: ActivityItem[] }) {
  const kinds = copy.contest.activity.kinds;
  return (
    <ol data-testid="activity-list" className="space-y-1">
      {items.map((item, i) => {
        const k = KIND[item.kind];
        return (
          <li key={`${item.at}-${item.actor}-${i}`} className="flex gap-4">
            <div className="flex flex-col items-center">
              <span
                title={kinds[item.kind]}
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-ground-edge bg-ground-raised"
              >
                <Icon name={k.icon} className={`h-4 w-4 ${k.tone}`} />
              </span>
              <span aria-hidden className="w-px flex-1 bg-ground-edge" />
            </div>
            <div className="min-w-0 pb-5">
              <p className="break-words text-[13px] leading-snug text-chrome">
                <span className="font-bold">@{item.actor}</span> {item.detail}
              </p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-chrome-dim">{timeAgo(item.at)}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
